import logo from '../../design/assets/logo.svg';
import logoBrown from '../../design/assets/logo-brown.svg';
import logoCream from '../../design/assets/logo-cream.svg';
import logoGold from '../../design/assets/logo-gold.svg';
import logoPeriwinkle from '../../design/assets/logo-periwinkle.svg';
import logoWhite from '../../design/assets/logo-white.svg';
import logoYellow from '../../design/assets/logo-yellow.svg';
import wordmark from '../../design/assets/HomePlatedTM.svg';
import appIcon from '../../design/assets/icons/web-app-icon-220x220.png';

/**
 * Port of the DS `Logo`: the plate-and-wordmark lockup in a colorway chosen
 * for the ground it sits on, the horizontal wordmark, or the square app icon
 * (collapsed sidebar). Assets are vendored in src/design/assets — never redraw.
 */
export type LogoVariant = 'orange' | 'brown' | 'cream' | 'gold' | 'periwinkle' | 'white' | 'yellow';

const LOCKUP: Record<LogoVariant, string> = {
  orange: logo,
  brown: logoBrown,
  cream: logoCream,
  gold: logoGold,
  periwinkle: logoPeriwinkle,
  white: logoWhite,
  yellow: logoYellow,
};

export interface LogoProps {
  variant?: LogoVariant;
  kind?: 'lockup' | 'wordmark' | 'icon';
  height?: number;
  alt?: string;
  className?: string;
}

export function Logo({ variant = 'orange', kind = 'lockup', height = 28, alt = 'HomePlated', className }: LogoProps) {
  const src = kind === 'wordmark' ? wordmark : kind === 'icon' ? appIcon : LOCKUP[variant];
  return (
    <img
      src={src}
      alt={alt}
      className={`block w-auto ${kind === 'icon' ? 'rounded-[7px]' : ''} ${className ?? ''}`}
      style={{ height }}
    />
  );
}
